import * as Lockr from 'lockr'
import md5 from 'js-md5'

const TokenKey = 'Admin-Token'
const md5key = "3Jr8S1K18rcC1wAfv8";

export function getToken() {
  return Lockr.get(TokenKey)
}

export function setToken(token) {
  Lockr.set(TokenKey, token)
  return Lockr.set(TokenKey, token)
}

export function removeToken() {
  return Lockr.rm(TokenKey)
}

export function getSign(params, timestamp) {
  let signStr = JSON.stringify(params) + "nonce" + timestamp + "" + md5key;
  var sign = md5(signStr);
  return sign
}
